import {getAcceptedKycDocumentTypes} from '@sollapay/domain';
import {DocumentContext, DocumentEntityType} from '@sollapay/enums';
import {useTranslation} from 'react-i18next';

import {buildDocumentTab, DocumentUploadTabs} from '@/features/documents';

import type {IdentityDocumentType, PartyType} from '@sollapay/enums';

export interface BuyerKycDocumentUploadProps {
  partyType: PartyType;
  idType?: IdentityDocumentType;
  trustAccountId: string;
  metadata: Record<string, string>;
  skipProcessing?: boolean;
  onDocumentsLoaded?: (documentIds: string[]) => void;
  onDocumentChange?: () => void;
}

/** Pass `skipProcessing` wherever no AI session consumes the extraction — otherwise it runs for nothing. */
export function BuyerKycDocumentUpload({
  partyType,
  idType,
  trustAccountId,
  metadata,
  skipProcessing,
  onDocumentsLoaded,
  onDocumentChange
}: BuyerKycDocumentUploadProps) {
  const {t} = useTranslation('common');
  const tabs = getAcceptedKycDocumentTypes({partyType, idType}).map(documentType =>
    buildDocumentTab(documentType, t)
  );

  return (
    <DocumentUploadTabs
      entityType={DocumentEntityType.TRUST_ACCOUNT}
      entityId={trustAccountId}
      documentContext={DocumentContext.KYC}
      metadata={metadata}
      metadataFilter={metadata}
      tabs={tabs}
      skipProcessing={skipProcessing}
      onDocumentsLoaded={onDocumentsLoaded}
      onDocumentChange={onDocumentChange}
    />
  );
}
